import { feedItems, heroImages } from "@/mocks/siteData";

const miniSteps = feedItems.slice(0, 3);

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-950 text-background-50">
      <img
        src={heroImages.cover}
        alt="52爆料正在追踪事件的神秘侦查与时间线主题插画"
        className="absolute inset-0 h-full w-full object-cover object-center opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-background-950" aria-hidden="true" />

      <div className="relative mx-auto flex w-full max-w-7xl flex-col gap-10 px-4 pb-16 pt-28 md:px-6 md:pb-20 md:pt-36">
        <div className="flex flex-col items-start gap-6 lg:max-w-[54%]">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-foreground-950/30 px-3 py-1.5 text-xs font-medium text-accent-200 backdrop-blur">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            LIVE · 正在追踪「拾光甄选助农专场风波」
          </span>

          <h1 className="font-heading text-[34px] font-black leading-[1.15] md:text-6xl">
            蹲更新，
            <span className="font-accent font-normal text-accent-400">就看 52爆料</span>
          </h1>
          <p className="max-w-xl text-[15px] leading-relaxed text-background-100/85 md:text-base">
            后续、反转、回应、时间线，一次给你梳理明白。别再翻十页评论凑真相，热门事件的每一步进展，
            都按时间顺序收好，越追越清晰，更新从不缺席。
          </p>

          <div className="mt-2 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => scrollTo("feed")}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-400"
            >
              看最新动态
              <i className="ri-arrow-down-line" />
            </button>
            <button
              type="button"
              onClick={() => scrollTo("timeline")}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/30 bg-white/5 px-6 py-3 text-sm font-bold text-background-50 backdrop-blur transition-colors hover:bg-white/10"
            >
              <i className="ri-list-check-2" />
              查看完整时间线
            </button>
          </div>

          <dl className="mt-4 flex items-center gap-6 text-sm text-background-100/80">
            <div>
              <dt className="sr-only">今日新增进展</dt>
              <dd className="font-heading text-xl font-bold text-background-50">3</dd>
              <span className="text-xs">今日新增进展</span>
            </div>
            <span className="h-8 w-px bg-white/15" aria-hidden="true" />
            <div>
              <dt className="sr-only">正被追踪事件数</dt>
              <dd className="font-heading text-xl font-bold text-background-50">38</dd>
              <span className="text-xs">正被追踪事件</span>
            </div>
            <span className="h-8 w-px bg-white/15" aria-hidden="true" />
            <div>
              <dt className="sr-only">阶段结论倒计时</dt>
              <dd className="font-heading text-xl font-bold text-background-50">D-2</dd>
              <span className="text-xs">阶段结论倒计时</span>
            </div>
          </dl>
        </div>

        <aside className="lg:absolute lg:right-6 lg:top-1/2 lg:w-[36%] lg:-translate-y-1/2">
          <div className="overflow-hidden rounded-2xl border border-white/10 bg-foreground-950/40 shadow-soft backdrop-blur-md">
            <div className="flex items-center justify-between border-b border-white/10 px-5 py-3">
              <div className="flex items-center gap-2">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-500" />
                </span>
                <span className="font-heading text-sm font-bold">正在更新 · 拾光甄选风波</span>
              </div>
              <span className="text-[11px] text-background-200/70">自动刷新中</span>
            </div>
            <ul className="divide-y divide-white/10">
              {miniSteps.map((it) => (
                <li key={it.id} className="px-5 py-4">
                  <div className="flex items-center gap-2 text-[11px]">
                    <span className="rounded bg-accent-500/20 px-2 py-0.5 font-bold text-accent-300">{it.tag}</span>
                    <span className="text-background-300/70">{it.timeLabel}</span>
                  </div>
                  <p className="mt-2 line-clamp-2 text-sm font-medium leading-relaxed text-background-50/95">
                    {it.title}
                  </p>
                </li>
              ))}
            </ul>
            <button
              type="button"
              onClick={() => scrollTo("feed")}
              className="group flex w-full items-center justify-center gap-2 bg-accent-500 px-5 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
            >
              展开全部更新
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </aside>
      </div>

      <div className="relative z-10 flex justify-center pb-6" aria-hidden="true">
        <span className="animate-bounce text-background-200/60">
          <i className="ri-arrow-down-s-line text-2xl" />
        </span>
      </div>
    </section>
  );
}